import { useCallback, useRef, useState } from 'react';
import { type ImpressionSchema } from '../../../../../../../shared/context/ListingsImpressionContainer/types/impressionSchema';
import { BASIC_GIG_CARD_IMPRESSION_NAME, BFF_OBSERVED_ITEM_INDEX } from './useBffRowObserver.constants';

export const useBffRowObserver = () => {
    const [isObservedItemSeen, setIsObservedItemSeen] = useState(false);
    const hasTriggered = useRef(false);

    const onImpression = useCallback((impressionData: Partial<ImpressionSchema> = {}) => {
        if (hasTriggered.current) {
            return;
        }

        if (impressionData.name !== BASIC_GIG_CARD_IMPRESSION_NAME) {
            return;
        }

        if ((impressionData.position_in_parent ?? 0) >= BFF_OBSERVED_ITEM_INDEX) {
            hasTriggered.current = true;
            setIsObservedItemSeen(true);
        }
    }, []);

    return {
        onImpression,
        bffEntryProps: {
            isObservedItemSeen,
            observedItemIndex: BFF_OBSERVED_ITEM_INDEX,
        },
    };
};
